export default __webpack_public_path__ + "static/media/cz.3a69a8ef.svg";